import styled from '@emotion/styled';

interface PropsType {
    stickyHeaderNew: boolean
}

export const ColumnTitle = styled('th', { label: 'ColumnTitle' })<PropsType>`
    position: ${({ stickyHeaderNew }): string => stickyHeaderNew ? 'sticky' : 'static'};
    background-color: ${({ stickyHeaderNew }): string => stickyHeaderNew ? '#c0c0c0' : 'transparent'};
    z-index: ${({ stickyHeaderNew }): string => stickyHeaderNew ? '2' : '0'};
`;
